// eslint-disable-next-line import/no-named-as-default
import { useProjectContext } from "components/project/projects/context";
import { useSelectedProjectPermissions } from "components/project/projects/hooks";
import { useDeleteProjectLinkedShapefileFolderMutation } from "components/project/shapefiles/mutations";

import { useUser } from "../../../../../../../hooks";
import { ACTION_TEXT } from "../constants/actionText.constants";
import { UseRightClickContextMenuReturn } from "../hooks/useRightClickContextMenu";
import { ShapefileFolderActions } from "./ShapefileFolderActions";

interface IProjectLinkedShapefileFolderActionsProps {
  setIsRenaming?: () => void;
  shapefileNodeId: string;
  isOrg?: boolean;
  isMcDan?: boolean;
  folderName: string;
  contextMenu?: UseRightClickContextMenuReturn;
  hasSelectItemsAction?: boolean;
}

/**
 * Some actions and properties have been left for dev to implement based on use case, since the properties are different between
 * the layer tree layers, and layer list layers.
 * @param params
 * @returns
 */
export function ProjectLinkedShapefileFolderActions(
  params: IProjectLinkedShapefileFolderActionsProps
): JSX.Element {
  const { selectedProjectId } = useProjectContext();

  const projectPermissions = useSelectedProjectPermissions();
  const { hasTrialAccount, isReadonly } = useUser();

  const deleteProjectShapefileFolderMutation =
    useDeleteProjectLinkedShapefileFolderMutation({
      projectId: selectedProjectId
    });

  return (
    <ShapefileFolderActions
      shapefileNodeId={params.shapefileNodeId}
      canExport={!hasTrialAccount && !isReadonly}
      hasSelectItems={params.hasSelectItemsAction ?? false}
      hasColorPicker={params.isOrg}
      isMcDan={params.isMcDan}
      isOrg={params.isOrg}
      isDisabled={!projectPermissions.canEditShapefiles}
      deleteSelectedItemsActionText={ACTION_TEXT.REMOVE_SELECTED_ITEMS}
      removeFolder={() =>
        deleteProjectShapefileFolderMutation.mutate({
          shapefileNodeId: params.shapefileNodeId,
          projectId: selectedProjectId,
          isOrg: params.isOrg
        })
      }
      folderName={params.folderName}
      contextMenu={params.contextMenu}
    />
  );
}
